import { useInsuranceEligibilityReportContainerContext } from '../../../providers/insurance-report-container.provider';
import { InsuranceVerificationReportHeader } from '../../components/InsuranceVerificationReportHeader';

export const InsuranceVerificationReportHeaderContainer = () => {
  const { locationData } = useInsuranceEligibilityReportContainerContext();

  if (!locationData?.Name) return null;

  return <InsuranceVerificationReportHeader closeInsuranceReportModal={() => {}} PMSName='' />;
};
